import React from 'react';
import {
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableRow,
	TextField,
	Typography,
} from 'components/mui';
import styles from './CheckpointEditor.module.css';
import { AddIcon, RemoveIcon } from 'components/icons';
import { v4 as uuidv4 } from 'uuid';

interface DropdownComponentProps {
	dropdowns: CheckpointDropdown[];
	dropdownType: CheckpointDropdownTypes | null;
	onUpdateDropdown: (updatedValues: CheckpointDropdown[]) => void;
	headerText: string;
}

const DropdownComponent: React.FC<DropdownComponentProps> = (props) => {
	const { dropdowns, dropdownType, onUpdateDropdown, headerText } = props;

	const onAddDropdownItemClick = () => {
		if (dropdownType === null) return;
		const updatedDropdownItems: CheckpointDropdown[] = [
			...dropdowns,
			{
				DropdownID: uuidv4(),
				Name: '',
				DropdownType: dropdownType,
				isError: true,
			},
		];
		onUpdateDropdown(updatedDropdownItems);
	};

	const onDeleteDropdownItemClick = (id: number | string) => {
		// Create a new array without the item at the given index
		const updatedDropdownItems = dropdowns.filter(
			(item) => item.DropdownID !== id,
		);
		onUpdateDropdown(updatedDropdownItems);
	};

	return (
		<Paper className={styles.table}>
			<Typography
				variant="h6"
				className={styles.wrap_header_text}
				fontWeight={400}
			>
				{headerText}
			</Typography>
			<Table size="small">
				<TableBody>
					{dropdowns
						.filter((item) => item.DropdownType === dropdownType)
						?.map((_dropdown, index: number) => (
							<TableRow key={`name-${index}`}>
								<TableCell>
									<TextField
										value={_dropdown.Name}
										className={styles.wrap_foo}
										size="small"
										label={`Item ${index + 1}`}
										variant="outlined"
										required
										multiline
										maxRows={4}
										error={_dropdown.isError}
										helperText={
											_dropdown.isError &&
											"Dropdown's name is required"
										}
										onChange={(e) => {
											const newDropdowns = dropdowns.map(
												(dropdown) => {
													if (
														dropdown.DropdownID ===
														_dropdown.DropdownID
													) {
														const name =
															e.target.value;

														return {
															...dropdown,
															isError:
																name === '',
															Name: name,
														};
													}
													return dropdown;
												},
											);
											onUpdateDropdown(newDropdowns);
										}}
									/>
								</TableCell>

								<TableCell>
									<IconButton
										onClick={() =>
											onDeleteDropdownItemClick(
												_dropdown.DropdownID,
											)
										}
									>
										<RemoveIcon />
									</IconButton>
								</TableCell>
							</TableRow>
						))}

					<TableRow>
						<TableCell>
							<IconButton onClick={onAddDropdownItemClick}>
								<AddIcon />
							</IconButton>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</Paper>
	);
};

export default DropdownComponent;
